export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/PartyShop-7ee1896b160ead3d99714f7172f0ef78.jpg";